<template>
    <b-modal scrollable ref="mdlTeamsystemintegrator" :title="title" centered no-close-on-backdrop no-close-on-esc hide-header-close size="xl" @ok="onOk">
        <div style="height: 100%">
            <div class="sa-flexbox" style="padding-bottom: 20px">
                <div class="sa-flexbox-header">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Tipo Documento</label>
                            <span class="sa-data">{{ jsonDataFattura.Testata.tipoDocumento }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Codice Fiscale</label>
                            <span class="sa-data">{{ jsonDataFattura.Testata.codiceFiscale }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Ragione Sociale</label>
                            <span class="sa-data">{{ jsonDataFattura.Testata.ragioneSociale }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Città</label>
                            <span class="sa-data">{{ jsonDataFattura.Testata.citta }} ({{ jsonDataFattura.Testata.provincia }})</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Cap</label>
                            <span class="sa-data">{{ jsonDataFattura.Testata.cap }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Indirizzo</label>
                            <span class="sa-data">{{ jsonDataFattura.Testata.indirizzo }}</span>
                        </b-col>
                    </b-row>
                </div>
                <div class="sa-flexbox-body">
                    <div class="b-table-sticky-header">
                        <b-table scrollable head-variant="light" class="sa-b-table" sticky-header ref="table" stacked="lg" striped hover :items="jsonDataFattura.Corpo" :fields="fields" sort-icon-left>
                            <template #cell(index)="row">
                                <span> {{ row.index + 1 }} </span>
                            </template>
                            <template v-slot:cell(articolo)="row">
                                <span v-if="row.index != jsonDataFattura.Corpo.length - 1">{{ row.item.descrizione }} ({{ row.item.codiceArticolo }})</span>
                                <b-form-select v-else v-model="row.item.codiceArticolo" class="mb-2 mr-sm-2 mb-sm-0" :options="prodottiOptions" :value="''" text-field="name" value-field="_id" @change="onchangeProdotto(row.item)"> </b-form-select>
                            </template>
                            <template v-slot:cell(quantita)="{ item }">
                                <b-form-input v-model="item.quantita" @input="onChangeValue(item)"></b-form-input>
                            </template>
                            <template v-slot:cell(aliquotaIva)="{ item }">
                                <b-form-select v-model="item.aliquotaIva" class="mb-2 mr-sm-2 mb-sm-0" :options="ivaOptions" :value="''" text-field="descrizione" value-field="aliquota"> </b-form-select>
                                <!-- <b-form-input v-model="item.quantita" @input="onChangeValue(item)"></b-form-input> -->
                            </template>
                            <template v-slot:cell(prezzoUnitario)="{ item }">
                                <!-- <span> {{ item.prezzoUnitario }} </span> -->
                                <b-form-input v-model="item.prezzoUnitario" @input="onChangeValue(item)"></b-form-input>
                            </template>
                            <template #cell(actions)="row">
                                <b-container class="bv-example-row">
                                    <b-button v-if="row.index == jsonDataFattura.Corpo.length - 1" size="sm" variant="btn btn-outline-success waves-effect waves-light width-sm no-text" @click="onAddRiga(jsonDataFattura.Corpo, row.item)">
                                        <b-icon icon="plus"></b-icon>
                                    </b-button>
                                </b-container>
                            </template>
                        </b-table>
                    </div>
                </div>
                <div class="sa-flexbox-footer">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right text-right">
                            <label class="sa-label-data">Totale:</label>
                            <span class="sa-data">{{ totaleDocuemnto }}</span>
                        </b-col>
                    </b-row>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
import UtilityMixin from "../../utility/UtilityMixin";
export default {
    mixins: [UtilityMixin],
    data() {
        return {
            pathResource: "/teamsystemintegratorresponse",
            pathResourceIva: "/teamsystemintegratoriva",
            pathResourceProdotti: "/externalprenotazioni/listaprodotti",
            title: "Modifica Fattura",
            ivaOptions: [],
            prodottiOptions: [],
            jsonData: {},
            totaleDocuemnto: 0,
            jsonDataFattura: { Testata: {}, Corpo: [] },
            fields: [
                {
                    label: "*",
                    key: "index",
                    thStyle: "width: 0.5rem",
                },
                {
                    label: "Articolo",
                    key: "articolo",
                    // thStyle: "width: 0.5rem",
                },
                {
                    label: "Iva",
                    key: "aliquotaIva",
                    thStyle: "width: 20rem",
                },
                {
                    label: "Quantita",
                    key: "quantita",
                    thStyle: "width: 5rem",
                },
                {
                    label: "U.M.",
                    key: "unitaMisura",
                    thStyle: "width: 5rem",
                },
                {
                    label: "Prezzo Unitario",
                    key: "prezzoUnitario",
                    thStyle: "width: 10rem",
                },
                {
                    label: "Totale",
                    key: "importoTotale",
                    thStyle: "width: 10rem",
                },
                {
                    key: "actions",
                    label: "",
                },
            ],
        };
    },
    methods: {
        init(id) {
            let me = this;
            me.id = id;
            me.$emit("beforeLoadData");
            me.loadIva();
            me.loadProdotti();
            me.loadData();
        },
        loadData() {
            let me = this;
            let link = me.pathResource + "/" + me.id;
            UtilityMixin.methods.loadDataResources(link, null, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.jsonData = response.data.data;
            me.jsonDataFattura = JSON.parse(me.jsonData.body);
            me.jsonDataFattura.Corpo.push({ unitaMisura: "NR", descrizione: "", codiceArticolo: "", quantita: "", prezzoUnitario: "", importoTotale: "", sconto1: "0", sconto2: "0", sconto3: "0", scontoImporto: "0", depositoDettaglio: "0", numeroColli: "1", contoMastro: "0", agenteDettaglio: "0" });
            me.$emit("afterLoadData");
            me.calcolaTotale();
            this.$refs.mdlTeamsystemintegrator.show();
        },
        loadDataError(error) {
            error;
            this.$emit("afterLoadData");
        },
        loadIva() {
            let me = this;
            let link = me.pathResourceIva;
            UtilityMixin.methods.loadDataResources(link, null, me.loadIvaSuccess, me.loadIvaError);
        },
        loadIvaSuccess(response) {
            let me = this;
            me.ivaOptions = response.data.data.list;
            me.ivaOptions.unshift({ aliquota: "", descrizione: "-Seleziona Valore-" });
        },
        loadIvaError(error) {
            error;
        },
        loadProdotti() {
            let me = this;
            let link = me.pathResourceProdotti;
            UtilityMixin.methods.loadDataResources(link, null, me.loadProdottiSuccess, me.loadProdottiError);
        },
        loadProdottiSuccess(response) {
            let me = this;
            me.prodottiOptions = response.data.data.products;
            me.prodottiOptions.push({ _id: "0", name: "Acconto Versato" });
            me.prodottiOptions.unshift({ _id: "", name: "-Seleziona Valore-" });
        },
        loadProdottiError(error) {
            error;
        },
        onOk() {
            let me = this;
            // me.$emit("beforeLoadData");
            let corpo = [];
            me.jsonDataFattura.Corpo.forEach((element) => {
                if (element.codiceArticolo !== "") {
                    corpo.push(element);
                }
            });
            me.jsonDataFattura.Corpo = corpo;
            me.jsonData.body = JSON.stringify(me.jsonDataFattura);
            me.saveResource(this.pathResource, this.jsonData, this.saveSuccess, this.saveError);
        },
        saveSuccess(response) {
            let me = this;
            response;
            // me.$emit("afterLoadData");
            me.$emit("afterSave");
        },
        saveError(error) {
            error;
            // this.$emit("afterLoadData");
        },
        onChangeValue(item) {
            const qta = parseFloat(String(item.quantita).replace(",", ".")) || 0;
            const prezzo = parseFloat(String(item.prezzoUnitario).replace(",", ".")) || 0;
            const totale = qta * prezzo;
            item.importoTotale = totale.toFixed(2).replace(".", ",");
            this.calcolaTotale();
        },
        calcolaTotale() {
            let me = this;
            me.totaleDocuemnto = 0;
            me.jsonDataFattura.Corpo.forEach((element) => {
                let totaleRiga = parseFloat(String(element.importoTotale).replace(",", ".")) || 0;
                me.totaleDocuemnto = me.totaleDocuemnto + totaleRiga;
            });
        },
        onAddRiga(array, value) {
            if (value.descrizione !== "") {
                array.push({ unitaMisura: "NR", descrizione: "", codiceArticolo: "", quantita: "", prezzoUnitario: "", importoTotale: "", sconto1: "0", sconto2: "0", sconto3: "0", scontoImporto: "0", depositoDettaglio: "0", numeroColli: "1", contoMastro: "0", agenteDettaglio: "0" });
            } else {
                this.$bvModal
                    .msgBoxOk("Dati non validi!", {
                        title: "ATTENZIONE",
                        size: "sm",
                        okVariant: "outline-danger",
                        headerClass: "sa-msg-header-danger",
                        footerClass: "p-2 border-top-0",
                        centered: true,
                    })
                    .then((value) => {
                        console.log(value);
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
        },
        onchangeProdotto(item) {
            let me = this;
            me.prodottiOptions.forEach((element) => {
                if (element._id === item.codiceArticolo) {
                    item.descrizione = element.name;
                }
            });
        },
    },
};
</script>

<style></style>
